import { gql } from '@apollo/client/core'
import { buildGraphqlQuery } from '@ztechapps/common.utils'

export const inventoryBySerialNumberFragment = gql`
  fragment inventoryBySerialNumberFragment on InventoryBySerialNumber {
    _id
    code
    transactionRef
    transactionType
    batchCode
    status
    tags
    remarks
    order {
      _id
      code
    }
  }
`

export const inventorybyserialnumberQueries = buildGraphqlQuery(
  'InventoryBySerialNumber',
  inventoryBySerialNumberFragment
)
